<template>
  <div class="addCredit">
    <van-form @submit="onSubmit" label-width="110px">
      <van-field
        v-model="subData.buyer_name"
        readonly
        @click="toBuyerList"
        name="buyer_name"
        label="客户"
        placeholder="请选择客户"
        right-icon="arrow"
      />
      <van-field
        readonly
        name="datetimePicker"
        v-model="subData.date"
        label="赊欠时间"
        placeholder="点击选择时间"
        right-icon="arrow"
        @click="showPicker = true"
      />
      <van-field
        v-model="subData.num"
        name="num"
        label="赊欠金额(元)"
        type="number"
        :min="0.00"
        :step="0.01"
        placeholder="请输入赊欠金额"
      />
      <van-field class="upload" name="uploader" label="上传赊欠记录" input-align="left">
        <template #input>
          <div class="ooo">
            <van-uploader
              v-model="subData.imgList"
              :before-read="beforeReadCredit"
              :before-delete="beforeDetaleCredit"
            />
          </div>
        </template>
      </van-field>
      <van-field
        v-model="subData.remark"
        input-align="left"
        rows="2"
        autosize
        label="备注"
        type="textarea"
        maxlength="200"
        placeholder="请输入备注"
        show-word-limit
      />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" color="#31b158">提交</van-button>
      </div>
    </van-form>

    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :value="new Date()"
        :max-date="new Date()"
        @confirm="onDateConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { uploadImg } from "@/api/public";
import { photoCompress } from "@/utils/photoCompress";
import { longtimestampToDate } from "@/utils/timestamp";
import { credit_create } from "@/api/work/credit/credit"
export default {
  name: "addCredit",
  data() {
    return {
      subData: {
        buyer_id: "",
        buyer_name: "",
        date: "",
        credit_time: "",
        num: "",
        img: "",
        imgList: [],
        remark: ""
      },

      showPicker: false
    };
  },
  created() {
    // 返回地址
    this.$navigation.on("back", (to, from) => {
      if (
        from.route.name == "manage_buyer_buyerManage" &&
        from.route.meta.backData
      ) {
        var data = from.route.meta.backData;
        this.subData.buyer_id = data.id;
        this.subData.buyer_name = data.name;
      }
    });
  },
  mounted() {},
  methods: {
    // 提交数据
    onSubmit() {
      if(!this.subData.buyer_id){ this.$toast("请选择客户！"); return false }
      if(!this.subData.credit_time){ this.$toast("请选择赊欠日期！"); return false }
      if(!(this.subData.num>0)){ this.$toast("请输入赊欠金额！"); return false }
      if(this.subData.imgList.length>0){
        var ili = []
        for (let i = 0; i < this.subData.imgList.length; i++) {
          const item = this.subData.imgList[i];
          ili.push(item.url)
        }
        this.subData.img = ili.join(",")
      }else{
        this.subData.img = ''
      }
      // if(this.subData.imgList.length<=0){ this.$toast("请上传图片！"); return false }
      credit_create(this.subData).then(res=>{
        if(res.code == 200){
          this.$toast.success(res.message);
          this.subData={
            buyer_id: "",
            buyer_name: "",
            date: "",
            credit_time: "",
            num: "",
            img: "",
            imgList: [],
            remark: ""
          }
        }
      })
    },
    // 去选择买家
    toBuyerList() {
      this.$router.push({
        path: "/manage/buyer/buyerManage",
        query: {
          use_type: 1,
          isCredit:1
        }
      });
    },

    // 选择日期
    onDateConfirm(date) {
      this.subData.date = longtimestampToDate(date);
      this.subData.credit_time = Math.floor(new Date(date).getTime() / 1000);
      this.showPicker = false;
    },

    /**
     * 上传赊欠记录
     */
    beforeReadCredit(file, index) {
      this.$toast.loading({
        message: "上传中...",
        duration: 0,
        forbidClick: true
      });
      photoCompress(file, res => {
        file = res;
        let fd = new FormData();
        fd.append("file[]", file);
        console.log(res);
        uploadImg(fd)
          .then(res => {
            console.log(res);
            this.$toast.clear();
            if (res.code == 200) {
              this.subData.imgList.push({
                url: res.data.resultInfo[0],
                isImage: true
              });
              return true;
            } else {
              return false;
            }
          })
          .catch(err => {
            this.$toast.clear();
            this.$toast.fail("上传失败");
            return false;
          });
      });
    },
    /**
     * 删除原产地证明
     */
    beforeDetaleCredit(file, index) {
      // this.subData.imgList.splice(index.index, index.index + 1);
      return true;
    },

  }
};
</script>

<style lang="less" scoped>
.addCredit {
  position: relative;
  min-height: calc(100% - 0.88rem);
}
</style>

<style lang="less">
.upload {
  flex-wrap: wrap;
  flex: auto;
  .van-field__value {
    margin-top: 10px;
    width: 100%;
    flex: auto;
  }
}
</style>